import { PendoMetaFields } from "globalConstants";
import { PendoDataType } from "types";

import { pendoConstants } from "./pendo.constants";

const {
	Id,
	Name,
	FirstName,
	LastName,
	AgentOffice,
	Email,
	MobilePhone,
	IsAgent,
	Role,
	Permissions,
	PartnerType,
	BusinessUnit,
	BusinessUnitHierarchy,
	Status,
	CreatedAt,
	StartDate,
	Package,
} = PendoMetaFields;

const initialState: PendoDataType = {
	visitor: {
		[Id.name]: null,
		[FirstName.name]: null,
		[LastName.name]: null,
		[AgentOffice.name]: null,
		[Email.name]: null,
		[MobilePhone.name]: null,
		[IsAgent.name]: null,
		[Role.name]: null,
		[Permissions.name]: null,
		[PartnerType.name]: null,
		[BusinessUnit.name]: null,
		[BusinessUnitHierarchy.name]: null,
	},
	account: {
		[Id.name]: null,
		[Name.name]: null,
		[PartnerType.name]: null,
		[Status.name]: null,
		[BusinessUnit.name]: null,
		[BusinessUnitHierarchy.name]: null,
		[CreatedAt.name]: null,
		[StartDate.name]: null,
		[Package.name]: null,
	},
} as PendoDataType;

export const pendoDataSelector = state => state.pendo;

const pendo = (state = initialState, action) => {
	switch (action.type) {
		case pendoConstants.INIT: {
			return {
				...state,
				...action.data,
			};
		}
		default: {
			return state;
		}
	}
};

export default pendo;
